import React from "react"
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart"
import SearchIcon from "@mui/icons-material/Search"
import { Info, Container, Image, Icon } from "../styles/ProductStyle"
import { Link } from "react-router-dom"
import { addProduct } from "../redux/cartRedux"
import { useDispatch } from "react-redux"

const Product = ({ item }) => {
  const dispatch = useDispatch()

  const addToCart = () => {
    dispatch(addProduct({ ...item, quantity: 1, price: item.price }))
  }
  return (
    <Container>
      {/* <Circle /> */}
      <Image src={item.image} />
      <Info>
        <Icon onClick={addToCart}>
          <AddShoppingCartIcon />
        </Icon>
        <Link to={`/product/${item.id}`}>
          <Icon>
            <SearchIcon />
          </Icon>
        </Link>
      </Info>
    </Container>
  )
}

export default Product
